<template>
  <div id="ModalDeleteConfirmation">
    <b-modal
      id="delete-confirmation-modal"
      hide-footer
      hideHeader
    >
      <template slot="default">
        <b-row>
          <b-col class="float-left">
            <em class="fas fa-lg fa-exclamation"></em>
          </b-col>
        </b-row>
        <b-container class="confirm-modal-cnt">
          <b-row class="text-center">
            <p class="confirm-modal-text">
              Вы действительно хотите удалить данный контент?
            </p>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-button @click="onDelete" class="confirm-modal-btn" variant="primary">
                Удалить
              </b-button>
            </b-col>
            <b-col sm="12" md="6">
              <b-button @click="closeModal" class="confirm-modal-btn" variant="outline-primary">
                Отмена
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ModalDeleteConfirmation',
  computed: {
    message: {
      get() {
        return this.$store.state.contentManager.deleteConfirmationMessage
      },
      set(value) {
        this.$store.commit('contentManager/updateDeleteConfirmationMessage', value)
      }
    }
  },
  props: {
    deleteHandler: {
      type: Function
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('delete-confirmation-modal')
    },
    onDelete(event) {
      if (this.deleteHandler !== undefined) {
        this.deleteHandler(event)
      } else {
        this.$parent.onDeleteClicked()
      }
    }
  }
}
</script>

<style scoped>
  .confirm-modal-btn {
    width: 100%;
  }

  .confirm-modal-text {
    display: inline-block;
    margin: 0 auto;
    width: 90%;
    margin-bottom: 20px;
  }

  .resetName {
    width: 100%;
    margin-bottom: 20px;
  }
</style>
